export const potmHeroWhiteListExactMatch = ['/projects', '/projects/'];
